import { useCallback, useEffect, useState } from "react";
import { getChickenHistoryApi } from "../api/chickenApi";
import { normalizeBet } from "../utils/chicken";

// GET /chicken/history -> { rows, loading, error, reload }
export default function useChickenHistory() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const res = await getChickenHistoryApi();
      const body = res.data;
      if (!body?.success || !Array.isArray(body.data)) throw new Error(body?.message || "History load nahi hui.");
      setRows(body.data.map(normalizeBet));
    } catch (e) {
      setError(e.response?.data?.message || e.message || "History load nahi hui.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { rows, loading, error, reload: load };
}
